import React from "react";

const Cart = () => {
  return <div>I am cart page !</div>;
};

export default Cart;
